import {TextField} from "@mui/material";
import moment from "moment";
import React from "react";

export function Form_Date(props) {
    const {item, localFormState, setLocalFormState} = props;
    const { inputSize = "normal" } = item;

    const [format, setFormat] = React.useState("yyyy-MM-DD");

    React.useEffect(() => {
        if (localFormState[item.key] === null || localFormState[item.key] === undefined) {
            // localFormState[item.key] = new Date();
            localFormState[item.key] = moment(new Date()).format(format);
        }
    }, [localFormState]);

    React.useEffect(() => {
        if (item.format !== undefined){
            setFormat(item.format);
        }
    }, [item])

    return (<>
        <TextField
            className={"w-100"}
            id="date"
            label={item.label}
            type="date"
            variant="outlined"
            size={inputSize}
            helperText={item.helperText}
            sx={{width: 220}}
            InputLabelProps={{
                shrink: true,
            }}
            value={
                (localFormState[item.key] === null || localFormState[item.key] === undefined) ? moment(new Date()).format(format) :
                    // moment(localFormState[item.key]).format("yyyy-MM-DD")
                moment(localFormState[item.key]).format(format)
            }
            onChange={
                (e) => {
                    // submit new state to the upper system
                    setLocalFormState({
                        ...localFormState,
                        [item.key]: e.target.value
                    });
                }
            }
        />
        {/*<pre>{JSON.stringify( (localFormState[item.key] === null || localFormState[item.key] === undefined) ? new Date().format("yyyy-MM-dd") :*/}
        {/*    new Date(localFormState[item.key]).format("yyyy-MM-dd"), undefined, 4 )}</pre>*/}
        {/*<pre>{JSON.stringify( localFormState[item.key], undefined, 4 )}</pre>*/}
        {/*<pre>{JSON.stringify( moment(localFormState[item.key]).format("yyyy-MM-DD"), undefined, 4 )}</pre>*/}
    </>)
}